import { configRefs } from '@utils/constants';
import { logger } from './Logger.js';

const cache = /* @__PURE__ */ new Map();
const setAlphaOnHexColor = (color, alpha) => {
  if (configRefs.env.node.dangerouslyAssertSyncValue() !== "production") {
    if (color.match(/^#?[0-9a-f]{3}/i) === null && color.match(/^#?[0-9a-f]{6}/i) === null) {
      logger.error(
        "setAlphaOnHexColor(...): color doesn't look like a hex",
        color
      );
    }
    if (alpha < 0 && alpha > 1) {
      logger.error(
        "setAlphaOnHexColor(): alpha should by a number between 0 and 1",
        color
      );
    }
  }
  const cacheKey = `${color}-${alpha.toString()}`;
  if (!cache.has(cacheKey)) {
    const hexaDecimals = color.replace(/^#/, "");
    const rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    if (hexaDecimals.length === 3) {
      rgb.r = hexToDigit(hexaDecimals.charAt(0).repeat(2));
      rgb.g = hexToDigit(hexaDecimals.charAt(1).repeat(2));
      rgb.b = hexToDigit(hexaDecimals.charAt(2).repeat(2));
    } else {
      rgb.r = hexToDigit(hexaDecimals.substr(0, 2));
      rgb.g = hexToDigit(hexaDecimals.substr(2, 2));
      rgb.b = hexToDigit(hexaDecimals.substr(4, 2));
    }
    cache.set(
      cacheKey,
      `rgba(${rgb.r.toString()}, ${rgb.g.toString()}, ${rgb.b.toString()}, ${alpha.toString()})`
    );
  }
  return cache.get(cacheKey);
};
function hexToDigit(hex) {
  return parseInt(hex, 16);
}

export { setAlphaOnHexColor };
//# sourceMappingURL=setAlphaOnHexColor.js.map
